import {createStore, combineReducers, compose, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import localReducer from './reducers/local'
import userReducer from './reducers/user'

const reducers = combineReducers({
    local: localReducer,
    user: userReducer
})

const storeConfig = () => {
    return createStore(reducers, compose(applyMiddleware(thunk)))
}

export default storeConfig